import React, { Component } from "react";
import styles from "./CatalogManagement.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import { AVAILABLE_MARKETS } from "../orders/AvailableMarkets";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import Grid from "@material-ui/core/Grid";
import CustomDropdown from "../../../../shared/subnav/CustomDropdown";
import VehicleCatalogClient from "../../../../shared/clients/VehicleCatalogClient";
import { withTranslation } from "react-i18next";
import { logMsg } from "../../../../common/Logger";
import CatalogDetails from "./CatalogDetails";
import SortData from "../../../../utils/SortUtil";
import CatalogManagementClient from "../../../../shared/clients/CatalogManagementClient";
import ConfirmDialog from "../../../../shared/confirmDialog/ConfirmDialog";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
class CatalogManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMarket: "GBR",
      listOfMarkets: undefined,
      sortDirection: "ASC",
      sortKey: "model",
      successDialog: false,
      successDialogProps: null,
      failureDialog: false,
      alterPADialog: false,
      alterInfoDialog: false,
      selectedCatalog: null,
      failureDialogProps: null,
      enableCatalogProps: null,
      disableCatalogProps: null,
      disableInfoCatalogProps: null,
      enableInfoCatalogProps: null,
    };
  }

  componentDidMount() {
    this.setState({
      listOfMarkets: this.props.groups,
    });
    let defaultUserMarket = this.props.selectedMarket?.toUpperCase();

    if (!AVAILABLE_MARKETS.hasOwnProperty(defaultUserMarket)) {
      if (defaultUserMarket === "SWE") {
        defaultUserMarket = "NOR";
      } else {
        defaultUserMarket = "GBR";
      }
    }
    const catalogId =
      this.state.selectedCatalog && this.props.selectedCatalog.catalogId;
    this.setState({ selectedMarket: defaultUserMarket });
    this.setState({
      successDialogProps: {
        title: "  ",
        bodyText: "Catalog has been added successfully",
        confirm: "close",
      },
      failureDialogProps: {
        title: "ERROR",
        bodyText:
          "Some thing went wrong with adding the Catalog please reach out to EMP IT team",
        confirm: "close",
      },
      enableCatalogProps: {
        title: "TRIGGER PENDING ACTION FOR THIS CATALOG",
        bodyText: this.props.t("DealerDashboard.itemsToBePricedDialogBody", {
          catalogId: catalogId,
        }),
        confirm: "CONFIRM",
        cancel: "CANCEL",
      },
      disableCatalogProps: {
        title: "REMOVE PENDING ACTION FOR THIS CATALOG",
        bodyText: "Do you want to remove a pending action for this catalog?",
        confirm: "CONFIRM",
        cancel: "CANCEL",
      },
      disableInfoCatalogProps: {
        title: "REMOVE INFORMATION PENDING ACTION FOR THIS CATALOG",
        bodyText:
          "Do you want to remove a Information pending action for this catalog?",
        confirm: "CONFIRM",
        cancel: "CANCEL",
      },
      enableInfoCatalogProps: {
        title: "TRIGGER INFORMATION PENDING ACTION FOR THIS CATALOG",
        bodyText:
          "Do you want to add an Information pending action for this catalog?",
        confirm: "CONFIRM",
        cancel: "CANCEL",
      },
    });
  }

  onSubmit = () => {
    this.fetchVehicleLines();
    this.getPendingActions();
  };

  onMarketChange = (event) => {
    event.preventDefault();
    const market = event.target.value;

    this.setState({
      selectedMarket: market,
      listOfMarkets: this.props.groups,
    });
  };
  onEditClick = (catalog) => {
    if (catalog.paActive) {
      const disableCatalogProps = this.state.disableCatalogProps;
      disableCatalogProps.bodyText = `Do you want to remove a pending action for catalog ID: ${catalog.catalogId}?`;
      this.setState({ disableCatalogProps });
    } else {
      const enableCatalogProps = this.state.enableCatalogProps;
      enableCatalogProps.bodyText = `Do you want to trigger a pending action for catalog ID: ${catalog.catalogId}?`;
      this.setState({ enableCatalogProps });
    }
    this.setState({ alterPADialog: true, selectedCatalog: catalog });
  };
  onInfoClick = (catalog) => {
    if (catalog.infoActive) {
      const disableInfoCatalogProps = this.state.disableInfoCatalogProps;
      disableInfoCatalogProps.bodyText = `Do you want to remove the Informational pending action for catalog ID: ${catalog.catalogId}?`;
      this.setState({ disableInfoCatalogProps });
    } else {
      const enableInfoCatalogProps = this.state.enableInfoCatalogProps;
      enableInfoCatalogProps.bodyText = `Do you want to trigger a Informational pending action for catalog ID: ${catalog.catalogId}?`;
      this.setState({ enableInfoCatalogProps });
    }
    this.setState({ alterInfoDialog: true, selectedCatalog: catalog });
  };

  saveNewCatalog = (request) => {
    this.props.hideOrShow(true);
    CatalogManagementClient.saveNewCatalogClient(this.props.user, request)
      .then(() => {
        this.setState({ successDialog: true });
      })
      .catch(() => {
        this.setState({ failureDialog: true });
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.onSubmit();
      });
  };
  changeMarket = (e) => {
    this.setState({
      selectedMarket: e.target.value,
    });
  };

  sortCatalogsData(sortByCol) {
    const that = this;
    SortData(
      sortByCol,
      this.state.sortDirection,
      "alphanumeric",
      this.state.catalogIds,
      function (sortedData) {
        that.setState({
          catalogIds: sortedData,
          sortKey: sortByCol,
        });
      }
    );
  }

  fetchVehicleLines() {
    this.props.hideOrShow(true);
    VehicleCatalogClient.getNscVehicleLines(
      this.props.user,
      false,
      this.state.selectedMarket
    )
      .then((catalogIds) => {
        this.setState({ catalogIds });
      })
      .catch((error) => {
        logMsg("reason", error);
      })
      .finally(() => {
        this.sortCatalogsData("model");
        this.props.hideOrShow(false);
      });
  }

  getPendingActions() {
    this.props.hideOrShow(true, true);
    PendingActionClient.getNscPendingActionsNotifications(
      this.props.user,
      this.state.selectedMarket
    )
      .then((data) => {
        this.filterPendingActionsData(data.pendingActions);
      })
      .catch(() => {
        this.pendingActions = [];
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  filterPendingActionsData(pendingActions) {
    const catalogIds = this.state.catalogIds;
    const paCatalogIds = pendingActions
      .filter(
        (action) =>
          action.actionName === "PRICING" &&
          Object.keys(action.attributes).length !== 0
      )
      .flatMap((action) => {
        return action.attributes.vehicleLines.map(
          (vehicleLine) => vehicleLine.catalogId
        );
      });
    const infoCatalogIds = pendingActions
      .filter(
        (action) =>
          action.actionName === "PRICE_CHANGE_INFO" &&
          Object.keys(action.attributes).length !== 0
      )
      .flatMap((action) => {
        return action.attributes.vehicleLines.map(
          (vehicleLine) => vehicleLine.catalogId
        );
      });
    catalogIds.forEach((catalog) => {
      catalog.paActive = !!paCatalogIds.includes(catalog.catalogId);
      catalog.infoActive = !!infoCatalogIds.includes(catalog.catalogId);
    });
    this.setState({ catalogIds });
  }

  closeAlterPADialog = () => {
    this.setState({ alterPADialog: false, selectedCatalog: null });
  };
  closeInfoDialog = () => {
    this.setState({ alterInfoDialog: false, selectedCatalog: null });
  };
  updatePAction = () => {
    this.props.hideOrShow(true);
    if (this.state.selectedCatalog.paActive === undefined) {
      const selectedCatalog = this.state.selectedCatalog;
      selectedCatalog.paActive = false;
      this.setState({ selectedCatalog });
    }
    PendingActionClient.updatePendingAction(
      this.props.user,
      this.state.selectedMarket,
      this.state.selectedCatalog.catalogId,
      this.state.selectedCatalog.paActive
    )
      .then(() => {
        const successDialogProps = this.state.successDialogProps;
        successDialogProps.bodyText =
          "Pending actions for the catalog was updated successfully";
        this.setState({ successDialog: true, successDialogProps });
        this.onSubmit();
      })
      .catch(() => {
        this.setState({ failureDialog: true });
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.closeAlterPADialog();
      });
  };
  updateInfoction = () => {
    this.props.hideOrShow(true);
    if (this.state.selectedCatalog.infoActive === undefined) {
      const selectedCatalog = this.state.selectedCatalog;
      selectedCatalog.infoActive = false;
      this.setState({ selectedCatalog });
    }
    PendingActionClient.updateInfoAction(
      this.props.user,
      this.state.selectedMarket,
      this.state.selectedCatalog.catalogId,
      this.state.selectedCatalog.infoActive
    )
      .then(() => {
        const successDialogProps = this.state.successDialogProps;
        successDialogProps.bodyText =
          "Information Pending action for the catalog was updated successfully";
        this.setState({ successDialog: true, successDialogProps });
        this.onSubmit();
      })
      .catch(() => {
        this.setState({ failureDialog: true });
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.closeInfoDialog();
      });
  };

  render() {
    return (
      <div>
        <section className="pageWrapper">
          {this.props.user.permissions.rolePermissions.hasOwnProperty(
            "searchLandingPage"
          ) && (
            <BackToButton
              backToUrl="/search"
              display={this.props.t("SearchWrapper.backToSearch")}
            />
          )}
          <SubNav
            dashboard={false}
            showCustomDropdown={false}
            showCustomMarketDropdown={false}
            selectedMarket={this.state.selectedMarket}
            listOfMarkets={this.state.listOfMarkets}
            updateMarket={this.onMarketChange}
            value={this.state.selectedMarket}
            dropDownValues={AVAILABLE_MARKETS}
            onChange={this.changeMarket}
            title="CATALOG MANAGEMENT"
            {...this.props}
          />
          <div className={styles.bottomPadding}>
            <div className={styles.indent}>
              <p className={styles.nscSearchSubHeader}>
                To search for a catalogs and Managing them.
              </p>
              <Grid container>
                <Grid item md={4} className={styles.dropdownGridStyle}>
                  <CustomDropdown
                    {...this.props}
                    value={this.state.selectedMarket}
                    onChange={this.changeMarket}
                    dropDownValues={AVAILABLE_MARKETS}
                    isFordBrand={true}
                  />
                </Grid>
                <Grid item md={3}>
                  <button
                    className={styles.searchButton}
                    id="searchBtn"
                    value=""
                    data-testid="searchBtn"
                    onClick={this.onSubmit}
                  >
                    SEARCH
                  </button>
                </Grid>
              </Grid>
            </div>
          </div>
          {this.state.catalogIds && (
            <CatalogDetails
              {...this.props}
              sortCatalogsData={this.sortCatalogsData}
              catalogIds={this.state.catalogIds}
              sortKey={this.state.sortKey}
              sortDirection={this.state.sortDirection}
              fetchVehicleLines={this.fetchVehicleLines}
              market={this.state.selectedMarket}
              saveNewCatalog={this.saveNewCatalog}
              onEditClick={this.onEditClick}
              onInfoClick={this.onInfoClick}
            />
          )}
          <ConfirmDialog
            open={this.state.successDialog}
            showWarningIcon={false}
            showOneButton={true}
            dialogProps={this.state.successDialogProps}
            onConfirm={() => this.setState({ successDialog: false })}
            onCancel={() => this.setState({ successDialog: false })}
            onClose={() => this.setState({ successDialog: false })}
            boldTitle={false}
            {...this.props}
          />
          <ConfirmDialog
            open={this.state.failureDialog}
            showWarningIcon={true}
            showOneButton={true}
            dialogProps={this.state.failureDialogProps}
            onConfirm={() => this.setState({ failureDialog: false })}
            onCancel={() => this.setState({ failureDialog: false })}
            onClose={() => this.setState({ failureDialog: false })}
            boldTitle={true}
            {...this.props}
          />
          {/*Pending Action Trigger Dialog*/}
          <ConfirmDialog
            open={this.state.alterPADialog}
            showWarningIcon={true}
            dialogProps={
              this.state.selectedCatalog && this.state.selectedCatalog.paActive
                ? this.state.disableCatalogProps
                : this.state.enableCatalogProps
            }
            onConfirm={() => this.updatePAction()}
            onCancel={this.closeAlterPADialog}
            onClose={this.closeAlterPADialog}
            boldTitle={false}
            {...this.props}
          />
          {/*Information Dialog*/}
          <ConfirmDialog
            open={this.state.alterInfoDialog}
            showWarningIcon={false}
            showOneButton={false}
            dialogProps={
              this.state.selectedCatalog &&
              this.state.selectedCatalog.infoActive
                ? this.state.disableInfoCatalogProps
                : this.state.enableInfoCatalogProps
            }
            onConfirm={() => this.updateInfoction()}
            onClose={this.closeInfoDialog}
            onCancel={this.closeInfoDialog}
            boldTitle={false}
            {...this.props}
          />
        </section>
      </div>
    );
  }
}

export default withTranslation("emp")(CatalogManagement);
